import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";

import { useConnect } from "../hooks/useConnect";

import { ACTION_UNSET_CONTRACTS } from "../store/actions/contract";
import { ACTION_UNSET_USER } from "../store/actions/user";

import Balance from "./Balance";
import CopyClipboard from "./common/CopyClipboard";

import icoEtherium from "../assets/img/ethereum.png";
import defoltAvatar from "../assets/img/user-Image17.png";

export const ModalProfile = () => {
	const { disconnect } = useConnect();
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.user);

	const showClassInit = "icon-hover-2 click-event3";
	const [showClass, setShowClass] = useState(showClassInit);

	const modalProfileToggle = () => {
		showClass === showClassInit
			? setShowClass("icon-hover-2 click-event3 displayblock")
			: setShowClass("icon-hover-2 click-event3");
	};
	const shotAccount = () => {
		if (user.account) {
			return user.account.slice(0, 6) + "..." + user.account.slice(-6);
		}
	};
	const getUserName = () => (user.name ? user.name : "Anonymous");

	const getAvatar = () => {
		if (user.image) {
			return `${process.env.REACT_APP_API_DO_URL}/${user.image}`;
		} else return defoltAvatar;
	};

	return (
		<div className="action-otr ms-auto" onClick={modalProfileToggle}>
			<div className="profile-otr">
				<span className="profile-inr click-open3">
					<img className="creator" src={getAvatar()} alt="creator" />
					<p className="price body-sb">{getUserName()}</p>
					<p className="price body-sb">
						<Balance />
					</p>
				</span>
				<div className={showClass}>
					<h5 className="heading heading-h5">{getUserName()}</h5>
					<div className="copy-icon-otr">
						<p className="desc body-s">{shotAccount()}</p>
						<CopyClipboard target={user.account} />
					</div>
					<div className="box-otr">
						<div className="img-otr">
							<img className="img-eht" src={icoEtherium} alt="img" />
						</div>
						<div className="price-otr">
							<p className="desc body-s">Current Balance</p>
							<h5 className="heading heading-h5">
								<Balance />
							</h5>
						</div>
					</div>
					<ul className="link-profile-otr">
						<li className="link-profile-inr">
							<span className="circle-hover"></span>
							<Link to="/user" className="profile body-sb">
								My Profile
							</Link>
						</li>
						<li className="link-profile-inr">
							<span className="circle-hover"></span>
							<Link
								to="/close/"
								className="profile body-sb"
								onClick={() => {
									disconnect();
									dispatch({ type: ACTION_UNSET_USER });
									dispatch({ type: ACTION_UNSET_CONTRACTS });
								}}
							>
								Disconnect
							</Link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};
